// client/src/api/ventas.js
import api from "./config.js";

// Obtener todas las ventas
export const getVentas = async () => {
    const { data } = await api.get("/ventas");
    return Array.isArray(data) ? data : data.ventas || [];
};

// Obtener venta por ID
export const getVenta = async (id) => {
    const { data } = await api.get(`/ventas/${id}`);
    return data.venta || data;
};

// Crear venta
export const createVenta = async (venta) => {
    const { data } = await api.post("/ventas", venta);
    return data.venta || data;
};

// Anular venta
export const anularVenta = async (id) => {
    const { data } = await api.put(`/ventas/anular/${id}`);
    return data.venta || data;
};
